import * as React from 'react';

import CloudUpload16 from './CloudUpload16';

export const cloudUpload16 = () => <CloudUpload16 />;

export default {
    title: 'Icon|Fill|CloudUpload16',
    component: CloudUpload16,
    parameters: {
        notes: "`import CloudUpload16 from 'box-ui-elements/es/icon/fill/CloudUpload16';`",
    },
};
